import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getUserInfo } from '../utils';
import { EntityTrailProvider } from '../context/EntityTrailContext';

export default function AuthRoute() {
	const location = useLocation();
	const userInfo = getUserInfo();
	if (!userInfo) {
		return <Navigate to='/signin' state={{ from: location }} replace />;
	}
	return (
		<EntityTrailProvider>
			<Outlet />
		</EntityTrailProvider>
	);
}
